export * from './agris-selector-ofic-suc.component';
export * from './selector-ofic-suc-dialog';


// WEBPACK FOOTER //
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/components/agris/common/agris-selector-ofic-suc/index.ts